// Tidewater Homes — compiles to assets/js/main.js
// npm run build:js   (one-off, minified)
// npm run watch:js    (rebuilds on save)

document.addEventListener( 'DOMContentLoaded', () => {
	const header = document.querySelector(".main-header");
	if(header) {
		const updateScrolledClass = () => {
			header.classList.toggle( 'scrolled', window.scrollY > 100 );
		};

		updateScrolledClass();
		window.addEventListener( 'scroll', updateScrolledClass, { passive: true } );
	}
} );
